import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>திவ்யதேசங்கள்</h1>
 <div class="div4">
   108 திவ்யதேசங்களுக்குமான அனைத்துத் தகவல்கள் 
   இங்கே வழங்கப்பட்டுள்ளன. 
   மேலும் சேர்க்க வேண்டிய தகவல்கள் அண்மைத் தகவல்கள் இருந்தால் 
   அனுப்பி வைத்தால் அவ்வப்போது சேர்த்து மேம்படுத்தி வெளியிடப்படும். 

 </div>
 
 <mat-accordion>
  <mat-expansion-panel>
  <mat-expansion-panel-header>திவ்ய தேச நாமாவளி
    </mat-expansion-panel-header>
    <div class="div3">
    1. ஸ்ரீரங்கம் 	: ஸ்ரீ ரங்கநாயிகா ஸமேத ஸ்ரீரங்கநாத	பரப்ரஹ்மணே நம:<br>	  2.	உறையூர் 	: ஸ்ரீ கமலவல்லி வாஸலக்ஷ;மீ நாயிகா ஸமேத சுந்தரவராய 	பரப்ரஹ்மணே நம:<br>
    3.	தஞ்சை	: (1) ஸ்ரீ செங்கமலவல்லி நாயிகா ஸமேத ஸ்ரீநீலமேக 	பரப்ரஹ்மணே நம:<br>
       (2) ஸ்ரீ அம்புஜவல்லீ நாயிகா ஸமேத ஸ்ரீ மணிபர்வத 	பரப்ரஹ்மணே நம:<br>
       (3) ஸ்ரீ தஞ்ச நாயிகா ஸமேத ஸ்ரீநரசிம்ஹ 	பரப்ரஹ்மணே நம:<br>
    4.	அன்பில் 	: ஸ்ரீ சௌந்;தர்யவல்லி நாயிகா ஸமேத ஸ்ரீசுந்தரமூர்த்தி பூர்ணாய 	பரப்ரஹ்மணே நம:<br>
    5.	உத்தமர் கோயில் 	: ஸ்ரீ பூர்ணவல்லி நாயிகா ஸமேத ஸ்ரீபுருஷோத்தம 	பரப்ரஹ்மணே நம:<br>
    6.	திருவெள்ளரை 	: ஸ்ரீ பங்கஜவல்லி நாயிகா ஸமேத ஸ்ரீபுண்டாPகாக்ஷ 	பரப்ரஹ்மணே நம:<br>
    7.	புள்ளபூதங்குடி	: ஸ்ரீ ஹேமாப்ஜ நாயிகா ஸமேத த்ருடதந்வீ ராமபத்ர 	பரப்ரஹ்மணே நம:<br>
    8.	கோயிலடி 	: ஸ்ரீ இந்த்ரவல்லி நாயிகா ஸமேத ஸ்ரீஅப்பால ரங்கநாத 	பரப்ரஹ்மணே நம:<br>
    9.	ஆதனு}ர் 	: ஸ்ரீ ரங்கநாயிகா ஸமேத ஸ்ரீவர்ஷகாலாதி நாயக 	பரப்ரஹ்மணே நம:<br>
   10.	தேரழுந்தூஃ; 	: ஸ்ரீ ரக்த பங்கஜவல்லி நாயிகா ஸமேத ஸ்ரீதேவாதிராஜ 	பரப்ரஹ்மணே நம:<br>
   11.	சிறு புலியூர் 	: ஸ்ரீ தயா நாயிகா ஸமேத ஸ்ரீ க்ருபாஸமுத்ர 	பரப்ரஹ்மணே நம:<br>
   12.	திருச்சேரை	: ஸ்ரீ ஸார நாயகி ஸமேத ஸ்ரீ ஸாரநாத 	பரப்ரஹ்மணே நம:<br>
   13.	தலைச்சங்காடு	: ஸ்ரீ சிரஸ் சங்க நாயிகா ஸமேத ஸ்ரீவ்யோமஜோதி 	பரப்ரஹ்மணே நம:<br>
   14.	குடந்தை 	: ஸ்ரீ கோமளவல்லி நாயிகா ஸமேத ஸ்ரீஅபர்யாப்தாம்ருத 	பரப்ரஹ்மணே நம:<br>
   15.	கண்டியூர்	: ஸ்ரீ கமலவல்லி நாயிகா ஸமேத ஸ்ரீஹரசாபவிமோசன 	பரப்ரஹ்மணே நம:<br>
   16.	ஒப்பிலியப்பன் 	: ஸ்ரீ பூதேவி நாயிகா ஸமேத ஸ்ரீலவணவர்ஜித ஸ்ரீநிவாஸ 	பரப்ரஹ்மணே நம:<br>
   17.	திருக்கண்ணபுரம் 	: ஸ்ரீ கண்ணபுர நாயிகா ஸமேத ஸ்ரீ சௌரிராஜ 	பரப்ரஹ்மணே நம:<br>
   18.	திருவாலி,திருநகரி 	: ஸ்ரீ அம்ருதகடவல்லி நாயிகா ஸமேத ஸ்ரீகேதாரபதிவராய 	பரப்ரஹ்மணே நம:<br>
   19.	நாகப்பட்டணம் 	: ஸ்ரீ சௌந்தர்யவல்லி நாயிகா ஸமேத ஸ்ரீ நீலமேக 	பரப்ரஹ்மணே நம:<br>
   20.	நாச்சியார் கோயில் 	: ஸ்ரீ வஞ்சுளவல்லி நாயிகா ஸமேத ஸ்ரீ ஸ்ரீநிவாஸ 	பரப்ரஹ்மணே நம:<br>
   21.	நாதன் கோயில் 	: ஸ்ரீ செம்பகவல்லி நாயிகா ஸமேத ஸ்ரீ ஜகன்நாத 	பரப்ரஹ்மணே நம:<br>
   22.	இந்தளூர் 	: ஸ்ரீ பரிமளரங்கநாயிகா ஸமேத ஸ்ரீ பரிமளரங்கநாத 	பரப்ரஹ்மணே நம:<br>
   23.	சிதம்பரம் 	: ஸ்ரீ புண்டாPகவல்லி நாயிகா ஸமேத ஸ்ரீ கோவிந்தராஜ 	பரப்ரஹ்மணே நம:<br>
   24.	சீர்காழி 	: ஸ்ரீ லோகநாயகி நாயிகா ஸமேத ஸ்ரீ லோகநாத த்ரிவிக்ரம 	பரப்ரஹ்மணே நம:<br>
   25.	ஆடுதுறை (கூடலு}ர்) 	: ஸ்ரீ பத்மாஸநி நாயிகா  ஸமேத ஸ்ரீ ஜகத்ரக்ஷக 	பரப்ரஹ்மணே நம:<br>
   26.	திருக்கண்ணங்குடி 	: ஸ்ரீ லோக நாயகீ ஸமேத ஸ்ரீ லோகநாயக 	பரப்ரஹ்மணே நம:<br>
   27.	திருக்கண்ணமங்கை 	: ஸ்ரீ அபிஷேகவல்லி நாயிகா ஸமேத ஸ்ரீ பக்தவத்சல 	பரப்ரஹ்மணே நம:<br>
   28.	கபிஸ்தலம் 	: ஸ்ரீ ரமாமணிவல்லி நாயிகா ஸமேத ஸ்ரீகஜேந்த்ர வரத 	பரப்ரஹ்மணே நம:<br>
   29.	திருவெள்ளியங்குடி 	: ஸ்ரீ மரகதவல்லி நாயிகா ஸமேத 
        ஸ்ரீ ச்ருங்காரஸுந்தர தநுஷ்பாணி ராமாய 	பரப்ரஹ்மணே நம:<br>
   30.	மணிமாடக் கோயில் 	: ஸ்ரீ புண்டாPகவல்லி நாயிகா ஸமேத ஸ்ரீ சாச்வத தீப நாராயணாய   	பரப்ரஹ்மணே நம:<br>
   31.	வைகுந்த விண்ணகரம் : ஸ்ரீ வைகுண்டவல்லி நாயிகா ஸமேத ஸ்ரீ வைகுண்டநாத 	பரப்ரஹ்மணே நம:<br>
   32.	அரிமேய விண்ணகரம் : ஸ்ரீ அம்ருதகடவல்லி நாயிகா ஸமேத ஸ்ரீ கடகேலி நர்த்தநாய  	பரப்ரஹ்மணே நம:<br>
   33.	தேவனார் தொகை 	: ஸ்ரீ ஸமுத்ரதநயா நாயிகா ஸமேத ஸ்ரீ தேவநாயக 	பரப்ரஹ்மணே நம:<br>
   34.	வண்புருடோத்தமம் 	: ஸ்ரீ புருஷோத்தம நாயிகா ஸமேத ஸ்ரீ புருஷோத்தம 	பரப்ரஹ்மணே நம:<br>
   35.	செம்பொன் செய் 	: ஸ்ரீ ச்வேத புஷ்பவல்லி நாயிகா ஸமேத ஸ்ரீ ஹேமரங்கநாத 	பரப்ரஹ்மணே நம:<br>
   36.	திருத்தெற்றியம்பலம் 	: ஸ்ரீ ரக்த பங்கஜவல்லி நாயிகா ஸமேத ஸ்ரீ லக்ஷ;மீரங்க 	பரப்ரஹ்மணே நம:<br>
   37. திருமணிக்கூடம் 	: ஸ்ரீ ஸ்ரீ பூ நாயிகா ஸமேத ஸ்ரீ வரதராஜ 	பரப்ரஹ்மணே நம:<br> 
   38. 	திருக்காவளம்பாடி 	: ஸ்ரீ பங்கஜவல்லி நாயிகா ஸமேத ஸ்ரீ கோலக்ருஷ்ண 	பரப்ரஹ்மணே நம:<br>
   39.	திருவெள்ளக்குளம் 	: ஸ்ரீ பத்மாவதி நாயிகா ஸமேத ஸ்ரீ ஸ்ரீநிவாஸ 	பரப்ரஹ்மணே நம:<br>
   40.	திருபார்த்தன் பள்ளி 	: ஸ்ரீ கமல நாயிகா ஸமேத ஸ்ரீபார்த்தஸாரதிரூப கமலாபதயே 	பரப்ரஹ்மணே நம:<br>
   41.	திருமாலிருஞ்சோலை 	: ஸ்ரீ சுந்தரவல்லி நாயிகா ஸமேத ஸ்ரீசோரசுந்தர 	பரப்ரஹ்மணே நம:<br>
   42.	திருக்கோட்டியூர் 	: ஸ்ரீ மஹாலக்ஷ;மி நாயிகா ஸமேத ஸ்ரீ உரக ம்ருது சயநாய 	பரப்ரஹ்மணே நம:<br>
   43.	திருமெய்யம் 	: ஸ்ரீ உஜ்ஜீவந நாயிகா ஸமேத ஸ்ரீ ஸத்யகிரிநாத 	பரப்ரஹ்மணே நம:<br>
   44.	திருப்புல்லாணி 	: ஸ்ரீ கல்யாணவல்லீ, ஸ்ரீ பத்மாஸநீ ஸமேத ஸ்ரீ கல்யாண ஜகந்நாத 	பரப்ரஹ்மணே நம:<br>
   45.	திருத்தண்கால் 	: ஸ்ரீ ரக்தபங்கஜவல்லீ நாயிகா ஸமேத ஸ்ரீ நாராயண 	பரப்ரஹ்மணே நம:<br>
   46.	திருமோகூர் 	: ஸ்ரீ மோஹநவல்லீ நாயிகா ஸமேத ஸ்ரீ காளமேக 	பரப்ரஹ்மணே நம:<br>
   47.	திருக்கூடல்; 	: ஸ்ரீ மதுரவல்லீ நாயிகா ஸமேத ஸ்ரீ ஸங்கம ஸுந்தராய 	பரப்ரஹ்மணே நம:<br>
   48.	ஸ்ரீ வில்லிபுத்துhர் 	: ஸ்ரீ கோதாதேவீ நாயிகா ஸமேத ஸ்ரீ வடபத்ரசாயீ 	பரப்ரஹ்மணே நம:<br>
   49.	திருக்குருகூர் 	: ஸ்ரீ ஆதிநாதவல்லீ நாயிகா ஸமேத ஸ்ரீ ஆதிநாத 	பரப்ரஹ்மணே நம:<br>
   50.	தொலைவில்லிமங்கலம் : ஸ்ரீ விசாலக்ருஷ்ணாக்ஷீதேவீ ஸமேத ஸ்ரீ அரவிந்தலோசந 	பரப்ரஹ்மணே நம:<br>
   51.	வானமாமலை 	: ஸ்ரீ ச்ரீவரமங்கைவல்லீ நாயிகா ஸமேத ஸ்ரீ தோத்தாத்ரிநாத 	பரப்ரஹ்மணே நம:<br>
   52.	திருப்புளிங்குடி 	: ஸ்ரீ ஸ்ரீ பூ நாயிகா ஸமேத ஸ்ரீ பூமிபாலாய வைரிணேதர்சிதகோபாய 	பரப்ரஹ்மணே நம:<br>
   53.	திருப்பேரை 	: ஸ்ரீ குண்டலகர்ணதேவீ நாயிகா ஸமேத ஸ்ரீ தீர்க்க மகர குண்டல தராய பரப்ரஹ்மணே நம:<br>
   54.	ஸ்ரீ வைகுண்டம் 	: ஸ்ரீ ஸ்ரீ பூ வைகுண்டவல்லீ நாயிகா ஸமேத ஸ்ரீவைகுண்டநாத 	பரப்ரஹ்மணே நம:<br>
   55.	திரு வரகுணமங்கை 	: ஸ்ரீ வரகுணவல்லீ நாயிகா ஸமேத ஸ்ரீ விஜயாஸந 	பரப்ரஹ்மணே நம:<br>
   56.	திருக்குளந்தை 	: ஸ்ரீ பாலிகாவல்லீ பத்மாவதீ நாயிகா ஸமேத ஸ்ரீ ஸ்ரீநிவாஸ 	பரப்ரஹ்மணே நம:<br> 
   57.	திருக்குறுங்குடி 	: ஸ்ரீ வாமந க்ஷேத்ரவல்லீ நாயிகா ஸமேத ஸ்ரீ வாமநக்ஷேத்ரபூர்;ணாய 	பரப்ரஹ்மணே நம:<br>
   58.	திருக்கோளூர் 	: ஸ்ரீ கோளூர்வல்லீ நாயிகா ஸமேத ஸ்ரீ வைகுண்டநாத 	பரப்ரஹ்மணே நம:<br>
   59.	திருவனந்தபுரம் 	: ஸ்ரீ ஹரிலக்ஷ;மீ நாயிகா ஸமேத ஸ்ரீ அநந்தபத்மநாப 	பரப்ரஹ்மணே நம:<br>
   60.	திருவண்பரிசாரம் 	: ஸ்ரீ கமலவல்லீ நாயிகா ஸமேத ஸ்ரீ வாமநாய 	பரப்ரஹ்மணே நம:<br>
   61.	திருக்காட்கரை 	: ஸ்ரீ வாத்ஸல்யவல்லீ நாயிகா ஸமேத ஸ்ரீகாட்கர ஸ்வாமி 	பரப்ரஹ்மணே நம:<br>
   62.	திருமூழிக்கள்ளம் 	: ஸ்ரீ மதுரவேணீ நாயிகா ஸமேத ஸ்ரீ ஸூக்திநாத 	பரப்ரஹ்மணே நம:<br>
   63.	திருப்புலியூர் 	: ஸ்ரீ ஹேமலதா நாயிகா ஸமேத ஸ்ரீ மாயாசக்தியுத ஸ்வாமி 	பரப்ரஹ்மணே நம:<br>
   64.	திருச்செங்குன்று}ர் 	: ஸ்ரீ ரக்தபங்கஜவல்லீ நாயிகா ஸமேத ஸ்ரீ தேவதிதேவ 	பரப்ரஹ்மணே நம:<br>
   65.	திருநாவாய் 	: ஸ்ரீ பத்மாவதி நாயிகா ஸமேத ஸ்ரீ நாராயண 	பரப்ரஹ்மணே நம:<br>
   66.	திருவல்லவாழ் 	: ஸ்ரீ வாத்ஸல்யவல்லீ நாயிகா ஸமேத ஸ்ரீ ஸுந்தராய 	பரப்ரஹ்மணே நம:<br>
   67.	திருவண்வண்டுர் 	: ஸ்ரீ கமலவல்லீ நாயிகா ஸமேத ஸ்ரீ கமலநாத 	பரப்ரஹ்மணே நம:<br>
   68.	திருவட்டாறு 	: ஸ்ரீ மரகதவல்லீ நாயிகா ஸமேத ஸ்ரீ ஆதிகேசவ 	பரப்ரஹ்மணே நம:<br>
   69.	திருவித்துவக்கோடு 	: ஸ்ரீ வித்துவக்கோடு வல்லீ நாயிகா ஸமேத ஸ்ரீ அபயப்ரதாய 	பரப்ரஹ்மணே நம:<br>
   70.	திருக்கடித்தானம் 	: ஸ்ரீ கல்பகவல்லீ நாயிகா ஸமேத ஸ்ரீ அம்ருதநாராயண 	பரப்ரஹ்மணே நம:<br>
   71.	திருவாரன்விளை 	: ஸ்ரீ பத்மாஸநீ நாயிகா ஸமேத ஸ்ரீ வாமந 	பரப்ரஹ்மணே நம:<br>
   72.	திருவஹீந்திபுரம் 	: ஸ்ரீ ஹேமாப்ஜவல்லீ நாயிகா ஸமேத ஸ்ரீ தேவநாயக 	பரப்ரஹ்மணே நம:<br>
   73.	திருக்கோவலு}ர் 	: ஸ்ரீ புஷ்பவல்லீ நாயிகா ஸமேத ஸ்ரீ த்ரிவிக்ரம 	பரப்ரஹ்மணே நம:<br>
   74.	திருக்கச்சி 	: ஸ்ரீ மஹாதேவீ நாயிகா ஸமேத ஸ்ரீ தேவாதிராஜ 	பரப்ரஹ்மணே நம:<br>
   75.	அட்டபுயகரம் 	: ஸ்ரீ பத்மாஸநீ நாயிகா ஸமேத ஸ்ரீ கஜேந்த்ரவரத 	பரப்ரஹ்மணே நம:<br>
   76.	திருத்தண்கா (தூப்புல்)	: ஸ்ரீ மரகதவல்லீ நாயிகா ஸமேத ஸ்ரீ தீபப்ரகாச 	பரப்ரஹ்மணே நம:<br>
   77.	திருவேளுக்கை(காஞ்)	: ஸ்ரீ அம்ருதவல்லீ  நாயிகா ஸமேத ஸ்ரீ ஸுந்தரயோகந்ருஸிம்ஹ 	பரப்ரஹ்மணே நம:<br>
   78.	திருப்பாடகம் (காஞ்)	: ஸ்ரீ ருக்மணீ, ஸத்யபாமா ஸமேத ஸ்ரீ பாண்டவதூத 	பரப்ரஹ்மணே நம:<br>
   79.	திருநீரகம் (காஞ்)	: ஸ்ரீ பூ வல்லீ நாயிகா ஸமேத ஸ்ரீ ஜகதீச்வர 	பரப்ரஹ்மணே நம:<br>
   80.	நிலாத்திங்கள் (காஞ்)	: ஸ்ரீ சந்த்ரசூடாவல்லீ நாயிகா ஸமேத ஸ்ரீ சந்த்ரசூட 	பரப்ரஹ்மணே நம:<br>
   81.	திரு ஊரகம் (காஞ்)	: ஸ்ரீ அமுதவல்லீ நாயிகா ஸமேத ஸ்ரீ த்ரிவிக்ரம 	பரப்ரஹ்மணே நம:<br>
   82.	திருவெக்கா (காஞ்)	: ஸ்ரீ கோமளவல்லீ நாயிகா ஸமேத ஸ்ரீ யதோத்காரி 	பரப்ரஹ்மணே நம:<br>
   83.	திருக்காரகம்; (காஞ்)	: ஸ்ரீ பத்மாமணி நாயிகா ஸமேத ஸ்ரீ கருணாகர 	பரப்ரஹ்மணே நம:<br>
   84.	திருக்கார்வானம்(காஞ்)	: ஸ்ரீ கமலவல்லீ நாயிகா ஸமேத ஸ்ரீ நீலமேக 	பரப்ரஹ்மணே நம:<br>
   85.	திருக்கள்வனு}ர் (காஞ்)	: ஸ்ரீ ஸுந்தரபிம்ப வல்லீ நாயிகா ஸமேத ஸ்ரீ சோரநாத 	பரப்ரஹ்மணே நம:<br>
   86.	திருப்பவளவண் (காஞ்)	: ஸ்ரீ ப்ரவாளவல்லீ நாயிகா ஸமேத ஸ்ரீ ப்ரவாளவர்ண 	பரப்ரஹ்மணே நம:<br>
   87.	பரமேச்சுரவிண்ணகர் “	: ஸ்ரீ வைகுண்டவல்லீ நாயிகா ஸமேத ஸ்ரீ வைகுண்டநாத 	பரப்ரஹ்மணே நம:<br>
   88.	திருப்புட்குழி	: ஸ்ரீ மரகதவல்லீ நாயிகா ஸமேத ஸ்ரீ விஜயராகவ 	பரப்ரஹ்மணே நம:<br>
   89.	திருநின்றவூர் 	: ஸ்ரீ ஸுதாவல்லீ நாயிகா ஸமேத ஸ்ரீ பக்தவத்ஸல 	பரப்ரஹ்மணே நம:<br>
   90.	திரு எவ்வுள்	: ஸ்ரீ கநகவல்லீ நாயிகா ஸமேத ஸ்ரீ வைத்ய வீரராகவ 	பரப்ரஹ்மணே நம:<br>
   91.	திருநீஃ;மலை	: ஸ்ரீ ஸுந்தரவல்லீ நாயிகா ஸமேத ஸ்ரீ ஜலதிவர்ணாய 	பரப்ரஹ்மணே நம:<br>
   92.	திருவிடவெந்தை 	: ஸ்ரீ கோமளவல்லீ நாயிகா ஸமேத ஸ்ரீ லக்ஷ;மீவராஹ 	பரப்ரஹ்மணே நம:<br>
   93.	திருக்கடன்மல்லை	: ஸ்ரீ பூஸ்தலமங்கா நாயிகா ஸமேத ஸ்ரீ ஸ்தலசயந 	பரப்ரஹ்மணே நம:<br>
   94.	திருவல்லிக்கேணி	: ஸ்ரீ ருக்மணீ நாயிகா ஸமேத ஸ்ரீ வேங்கடக்ருஷ்ண 	பரப்ரஹ்மணே நம:<br>
   95.	கடிகை (சோளிங்கர்)	: ஸ்ரீ அம்ருதபலவல்லீ நாயிகா ஸமேத ஸ்ரீ யோகந்ருஸிம்ஹ 	பரப்ரஹ்மணே நம:<br>
   96.	திருவேங்கடம்	: ஸ்ரீ பத்மாவதி நாயிகா ஸமேத ஸ்ரீ ஸ்ரீநிவாஸ 	பரப்ரஹ்மணே நம:<br>
   97.	சிங்கவேள்குன்றம்	: ஸ்ரீ அம்ருதவல்லீ, செஞ்சுலக்ஷ;மீ  ஸமேத ஸ்ரீ லக்ஷ;மீ ந்ருஸிம்ஹ 	பரப்ரஹ்மணே நம:<br>
   98.	திருவயோத்தி	: ஸ்ரீ ஸீதாதேவீ நாயிகா ஸமேத ஸ்ரீ ராமசந்த்ர 	பரப்ரஹ்மணே நம:<br>
   99.	நைமிசாரண்யம்	: ஸ்ரீ ஹரிலக்ஷ;மி நாயிகா ஸமேத ஸ்ரீ தேவராஜ 	பரப்ரஹ்மணே நம:<br>
  100.	சாளக்கிராமம்	: ஸ்ரீ ஸ்ரீதேவி ஸமேத ஸ்ரீ ஸ்ரீமூர்த்தி 	பரப்ரஹ்மணே நம:<br>
  101.	பத்ரிகாச்ரமம்	: ஸ்ரீ அரவிந்தவல்லீ நாயிகா ஸமேத ஸ்ரீ ஸ்ரீபதாPநாராயண	பரப்ரஹ்மணே நம:<br>
  102.	தேவப்ரயாகை	: ஸ்ரீ புண்டாPகவல்லீ நாயிகா ஸமேத ஸ்ரீ நீலமேக 	பரப்ரஹ்மணே நம:<br>
  103.	திருப்ரிதி	: ஸ்ரீ பரிமளவல்லீ நாயிகா ஸமேத ஸ்ரீ பரமபுருஷாய 	பரப்ரஹ்மணே நம:<br>
  104.	திரு த்வாரகை	: ஸ்ரீ லக்ஷ;மீ ஸ்ரீருக்மண்யாதி அஷ்டமஹிஷீ ஸமேத ஸ்ரீ த்வாரகாதீச 	பரப்ரஹ்மணே நம:<br>
  105.	வடமதுரை	: ஸ்ரீ ஸத்யபாமா நாயிகா ஸமேத ஸ்ரீ கோவர்த்தநகரிதாரி 	பரப்ரஹ்மணே நம:<br>
  106.	திருவாய்;ப்பாடி 	: ஸ்ரீ ருக்மணீ, ஸத்யபாமா ஸமேத ஸ்ரீ நவமோஹநக்ருஷ்ண 	பரப்ரஹ்மணே நம:<br>
  107.	திருப்பாற்கடல்	: ஸ்ரீ ஸ்ரீ பூ, ஸ்ரீ ஸமுத்ரதநயா நாயிகா ஸமேத ஸ்ரீ க்ஷீராப்திநாத 	பரப்ரஹ்மணே நம:<br>
  108.	பரமபதம் 	: ஸ்ரீ மஹாலக்ஷ;ம்யா ஸமேத ஸ்ரீ பரமபதநாதாய 	பரப்ரஹ்மணே நம:<br>
</div>  
</mat-expansion-panel>

  <div *ngFor="let data of dds; let i = index;">
   <mat-expansion-panel>
     
     <mat-expansion-panel-header>{{i+1}} - {{data?.ddname}}
     </mat-expansion-panel-header>  
      <div class="greenhd">{{data?.ddname}}</div>
    <div class="div3">
      <!-- <img src="assets/ddimg/001.jpg" /> -->
      <img src="assets/ddpic/({{i+1}}).jpg" alt="Divyadesam Picture" /> 
      
      <span class="hint">சிறு குறிப்பு:-</span>{{data?.description}}
      <hr class="style2">
      <span class="hint">மூலவர்:-</span>{{data?.moolavar}}
      <hr class="style2">
      <span class="hint">உத்ஸவர்:-</span>{{data?.uthsavar}}
      <hr class="style2">
      <span class="hint">தாயார்:-</span>{{data?.thaayaar}}
      <hr class="style2">
      <span class="hint">தீர்த்தம்:-</span>{{data?.dheerthams}}
      <hr class="style2">
      <span class="hint">ஸ்தலவ்ருக்ஷம்:-</span>{{data?.sthalavruksham}}
      <hr class="style2">
      <span class="hint">விமானம்:-</span>{{data?.vimaanam}}
      <hr class="style2">
      <span class="hint">ப்ரத்யக்ஷம்:-</span>{{data?.prathyaksham}}
      <hr class="style2">
      <span class="hint">மங்களாசாஸனம்:-</span>{{data?.mangalasasanam}}
      <hr class="style2">
      <span class="hint">மொத்த பாசுரங்கள்:-</span>{{data?.totalpaasuram}}
      <hr class="style2">
      <span class="hint">விசேஷம்:-</span>{{data?.visesham}}
      <hr class="style2">
      <span class="hint">விளக்கம்1:-</span>{{data?.hints1}}
      <hr class="style2">
      <span class="hint">விளக்கம்2:-</span>{{data?.hints2}}
      <hr class="style2">
      <span class="hint">விளக்கம்3:-</span>{{data?.hints3}}
      
     
    </div> 
   </mat-expansion-panel>
  </div>
    </mat-accordion>`;

const DivyadesamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="திவ்யதேசங்கள் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default DivyadesamPage;
